export type paramsType = 's' | 'd';

export enum NonRegisteredClientDocumentTypes {
  s = 'sign',
  d = 'display',
}
